import "./SubmitButton.css";

import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

/**
 * Renders a purple submit button with an optional loading state as indicated
 * by `isLoading`. This mimics Schumacher's `Button` but it doesn't require
 * generating all links and using preval like the original.
 */
export default function SubmitButton({
  children,
  className,
  "data-testid": dataTest,
  isLoading,
}) {
  return (
    <button
      className={classnames(`submitButton`, {
        [className]: className,
        "is-loading": isLoading,
      })}
      data-testid={dataTest}
      type="submit"
    >
      {children}
    </button>
  );
}

SubmitButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  "data-testid": PropTypes.string,
  isLoading: PropTypes.bool,
};

SubmitButton.defaultProps = {
  children: null, // eslint-disable-line unicorn/no-null
  className: undefined,
  "data-testid": undefined,
  isLoading: false,
};
